import { Routes } from "@angular/router";
import { ActivateGuard } from "./guards/activate/activate.guard";
import { DeactivateGuard } from "./guards/deactivate/deactivate.guard";
import { StepComponent } from "./step/step.component";
import { ThankyouComponent } from "./thankyou/thankyou.component";

export const routes: Routes = [
  {
    path: 'step',
    children: [
      {
        path: ':id',
        component: StepComponent,
        canDeactivate: [DeactivateGuard],
        canActivate: [ActivateGuard]
      }
    ]
  },
  {
    path: 'thankyou',
    component: ThankyouComponent
  }
]